const type = 'length';
const metre = {
    name: 'metre',
    symbol: 'm',
    ratio: 1,
    type,
    isPrefixable: true
};
/**
 * Yard - Imperial length base unit.
 * Since 1959 it is by international agreement standardized as exactly 0.9144 meters.
 * https://en.wikipedia.org/wiki/International_yard_and_pound
 */
const yard = {
    name: 'yard',
    symbol: 'yd',
    ratio: metre.ratio * 0.9144,
    type
};
const foot = {
    name: 'foot',
    symbol: 'ft',
    alternativeSymbol: '′',
    ratio: yard.ratio / 3,
    type
};
const inch = {
    name: 'inch',
    symbol: 'in',
    alternativeSymbol: '″',
    ratio: foot.ratio / 12,
    type
};
const chain = {
    name: 'chain',
    symbol: 'ch',
    ratio: yard.ratio * 22,
    type
};
const furlong = {
    name: 'furlong',
    symbol: 'fur',
    ratio: chain.ratio * 10,
    type
};
const mile = {
    name: 'mile',
    symbol: 'mi',
    ratio: furlong.ratio * 8,
    type
};
const league = {
    name: 'league',
    symbol: 'lea',
    ratio: mile.ratio * 3,
    type
};
/**
 * Nautical Mile (M)
 * https://www.bipm.org/utils/common/pdf/si_brochure_8_en.pdf
 */
const nautical_mile = {
    name: 'nautical_mile',
    symbol: 'M',
    ratio: metre.ratio * 1852,
    type
};

const type$1 = 'area';
const are = {
    name: 'are',
    symbol: 'a',
    ratio: metre.ratio * 100,
    type: type$1
};
const hectare = {
    name: 'hectare',
    symbol: 'ha',
    ratio: are.ratio * 100,
    type: type$1
};
const acre = {
    name: 'acre',
    symbol: 'ac',
    ratio: Math.pow(yard.ratio, 2) * 4840,
    type: type$1
};

const type$2 = 'volume';
/**
 * Litre is not SI unit (cubic meters are SI unit for volume).
 * Can use SI prefixes.
 */
const litre = {
    name: 'litre',
    symbol: 'l',
    alternativeSymbol: 'ℓ',
    ratio: metre.ratio * 0.001,
    isPrefixable: true,
    type: type$2
};
/**
 * U.S. Gallon. (U.K. gallon is deprecated?)
 * 3.785411784 litres
 */
const gallon = {
    name: 'gallon',
    symbol: 'gal',
    ratio: Math.pow(inch.ratio, 3) * 231,
    type: type$2
};
const quart = {
    name: 'quart',
    symbol: 'qt',
    ratio: gallon.ratio / 4,
    type: type$2
};
/**
 * Imperial (U.S.) Pint is 1/8 gallon
 */
const pint = {
    name: 'pint_short',
    symbol: 'pt',
    ratio: gallon.ratio / 8,
    type: type$2
};
/**
 * Imperial (U.K.) Pint is 568ml
 */
const pint_long = {
    name: 'pint_long',
    symbol: 'pint',
    ratio: litre.ratio * 0.568,
    type: type$2
};
const gill = {
    name: 'gill',
    symbol: 'gi',
    ratio: gallon.ratio / 32,
    type: type$2
};
const fluid_ounce = {
    name: 'fluid_ounce',
    symbol: 'fl oz',
    ratio: gallon.ratio / 128,
    type: type$2
};
const peck = {
    name: 'peck',
    symbol: 'pk',
    ratio: litre.ratio * 8.809768,
    type: type$2
};
const bushel = {
    name: 'bushel',
    symbol: 'bu',
    ratio: litre.ratio * 35.23907016688,
    type: type$2
};

const type$3 = 'mass';
/**
 * Base SI unit for mass is actually kg
 * and its value will be used as base ratio
 * but we will define only gram,
 * because it is prefixable unit
 */
const gram = {
    name: 'gram',
    symbol: 'g',
    ratio: 0.001,
    isPrefixable: true,
    type: type$3
};
const tonne = {
    name: 'tonne',
    symbol: 't',
    ratio: gram.ratio * 1000000,
    description: 'Tonne (metric ton) - 1000 kg - SI accepted unit.',
    type: type$3
};
const pound = {
    name: 'pound',
    symbol: 'lb',
    ratio: gram.ratio * 453.59237,
    type: type$3
};
const grain = {
    name: 'grain',
    symbol: 'gr',
    ratio: pound.ratio / 7000,
    type: type$3
};
const drachm = {
    name: 'drachm',
    symbol: 'dr',
    ratio: pound.ratio / 256,
    type: type$3
};
const ounce = {
    name: 'ounce',
    symbol: 'oz',
    ratio: pound.ratio / 16,
    type: type$3
};
const stone = {
    name: 'stone',
    symbol: 'st',
    ratio: pound.ratio * 14,
    type: type$3
};
const quarter = {
    name: 'quarter',
    symbol: 'qr',
    ratio: pound.ratio * 25,
    type: type$3
};
const hundredweight_long = {
    name: 'hundredweight_long',
    symbol: 'longcwt',
    ratio: pound.ratio * 112,
    type: type$3
};
const hundredweight_short = {
    name: 'hundredweight_short',
    symbol: 'cwt',
    ratio: pound.ratio * 100,
    type: type$3
};
const ton_long = {
    name: 'ton_long',
    symbol: 'longton',
    ratio: pound.ratio * 2240,
    type: type$3
};
const ton_short = {
    name: 'ton_short',
    symbol: 'ton',
    ratio: pound.ratio * 2000,
    type: type$3
};

const units = {
    metre,
    yard,
    foot,
    inch,
    chain,
    furlong,
    mile,
    league,
    nautical_mile,
    are,
    hectare,
    acre,
    litre,
    gallon,
    quart,
    pint,
    pint_long,
    gill,
    fluid_ounce,
    peck,
    bushel,
    gram,
    tonne,
    pound,
    grain,
    drachm,
    ounce,
    stone,
    quarter,
    hundredweight_long,
    hundredweight_short,
    ton_long,
    ton_short
};

const yotta = {
    name: 'yotta',
    symbol: 'Y',
    ratio: 1e24
};
const zetta = {
    name: 'zetta',
    symbol: 'Z',
    ratio: 1e21
};
const exa = {
    name: 'exa',
    symbol: 'E',
    ratio: 1e18
};
const peta = {
    name: 'peta',
    symbol: 'P',
    ratio: 1e15
};
const tera = {
    name: 'tera',
    symbol: 'T',
    ratio: 1e12
};
const mega = {
    name: 'mega',
    symbol: 'M',
    ratio: 1e6
};
const kilo = {
    name: 'kilo',
    symbol: 'k',
    ratio: 1e3
};
const hecto = {
    name: 'hecto',
    symbol: 'h',
    ratio: 1e2
};
const deca = {
    name: 'deca',
    symbol: 'da',
    ratio: 1e1
};
const deci = {
    name: 'deci',
    symbol: 'd',
    ratio: 1e-1
};
const centi = {
    name: 'centi',
    symbol: 'c',
    ratio: 1e-2
};
const milli = {
    name: 'milli',
    symbol: 'm',
    ratio: 1e-3
};
const micro = {
    name: 'micro',
    symbol: 'μ',
    ratio: 1e-6
};
const nano = {
    name: 'nano',
    symbol: 'n',
    ratio: 1e-9
};
const pico = {
    name: 'pico',
    symbol: 'p',
    ratio: 1e-12
};
const femto = {
    name: 'femto',
    symbol: 'f',
    ratio: 1e-15
};
const atto = {
    name: 'atto',
    symbol: 'a',
    ratio: 1e-18
};
const zepto = {
    name: 'zepto',
    symbol: 'z',
    ratio: 1e-21
};
const yocto = {
    name: 'yocto',
    symbol: 'y',
    ratio: 1e-24
};
const prefixes = [
    yotta,
    zetta,
    exa,
    peta,
    tera,
    mega,
    kilo,
    hecto,
    deca,
    // 1e0
    deci,
    centi,
    milli,
    micro,
    nano,
    pico,
    femto,
    atto,
    zepto,
    yocto
];

const SQUARE_SYMBOLS = ['²', '2'];
const CUBE_SYMBOLS = ['³', '3'];
const findUnit = (unitKey) => {
    let trimmed = unitKey.trim();
    const lastCharacter = trimmed.slice(-1);
    let suffix = '';
    let exponent = 1;
    if (SQUARE_SYMBOLS.includes(lastCharacter)) {
        suffix = SQUARE_SYMBOLS[0];
        exponent = 2;
        trimmed = trimmed.slice(0, -1);
    }
    if (CUBE_SYMBOLS.includes(lastCharacter)) {
        suffix = CUBE_SYMBOLS[0];
        exponent = 3;
        trimmed = trimmed.slice(0, -1);
    }
    // find unit
    let unit = Object.values(units).find(({ name, symbol, alternativeSymbol }) => {
        return (trimmed === symbol ||
            trimmed === name ||
            (alternativeSymbol && trimmed === alternativeSymbol));
    });
    // find prefix
    let prefix = !unit && prefixes.find(siPrefix => trimmed.startsWith(siPrefix.symbol));
    if (prefix && prefix.symbol) {
        trimmed = trimmed.substring(prefix.symbol.length);
    }
    // const [prefix] = unit.split(this.symbol)
    // find unit
    unit = Object.values(units).find(({ name, symbol, alternativeSymbol }) => {
        return (trimmed === symbol ||
            trimmed === name ||
            (alternativeSymbol && trimmed === alternativeSymbol));
    });
    if (!unit) {
        throw Error(`Unit "${trimmed}" not found!`);
    }
    let ratio = 1;
    if (unit) {
        ratio *= unit.ratio;
    }
    if (prefix) {
        ratio *= prefix.ratio;
    }
    ratio = Math.pow(ratio, exponent);
    return {
        unit: (unit && unit.symbol) || '',
        prefix: (prefix && prefix.symbol) || '',
        suffix,
        ratio,
        unitKey
    };
};

/**
 * Create a function for rounding with predefined settings.
 *
 * @param exponent how many numbers after comma should be left?
 * @param roundingFunction which function should be used for rounding? default: `Math.round`
 * @param epsilon floating point number patching
 */
function rounder(exponent = 2, roundingFunction = Math.round, epsilon = Number.EPSILON) {
    const pow = Math.pow(10, exponent);
    return function round(value) {
        const sign = value < 0 ? -1 : 1;
        const absoluteValue = value * sign;
        return (roundingFunction(absoluteValue * pow + epsilon) / pow) * sign;
    };
}

/**
 * Measure of value with unit.
 * Length, area, volume and mass units.
 * SI, metric and imperial units.
 * Squared and cubed length units (m2, m3, km2, m3, ft3, mi2).
 * SI prefixes (da, h, k, M, G, T, P, E, Z, Y, d, c, m, μ, n, p, f, a, z, y) for (m, m2, m3, l, g) i.e. (km2, kg, cm, ml).
 *
 * @returns {Number|String} `Measure.valueOf(): Number` or `Measure.toString(): String` depending on context
 */
class Measure extends Number {
    /**
     * @param value value/quantity of unit
     * @param unitKey key representation of unit
     */
    constructor(value, unitKey = 'm') {
        super(value);
        this.precision = 12;
        this.exponent = 1;
        this.ratio = 1;
        this.unitKey = 'm';
        this.symbol = 'm';
        this.prefix = '';
        this.suffix = '';
        this.round = 2;
        /**
         * Convert Measure to another Measure with different Unit.
         *
         * @param unitKey key representation of unit
         */
        this.to = (unitKey) => {
            const { unit, prefix, suffix, ratio } = findUnit(unitKey);
            this.unitKey = unitKey;
            this.symbol = unit;
            this.prefix = prefix;
            this.suffix = suffix;
            const newRatio = 1 / ratio;
            const newValue = +this / this.ratio / ratio;
            this.ratio = newRatio;
            return this.clone(newValue);
        };
        /**
         * Returns the value of this instance as a number
         */
        this.valueOf = () => {
            return parseFloat(this.toPrecision(this.precision));
        };
        /**
         * Returns the string representation for this instance.
         */
        this.toString = () => {
            const rounded = rounder(this.round)(this.valueOf());
            return `${rounded} ${this.extension}`;
        };
        if (unitKey) {
            this.unitKey = unitKey;
            const { unit, prefix, suffix, ratio } = findUnit(unitKey);
            this.symbol = unit;
            this.prefix = prefix;
            this.suffix = suffix;
            this.ratio = 1 / ratio;
        }
    }
    /**
     * Create a copy of of Measure with new value.
     * Why? Because value of Number that we extend is immutable.
     *
     * @param value new value
     */
    clone(value) {
        const measure = new Measure(value);
        measure.ratio = this.ratio;
        measure.unitKey = this.unitKey;
        measure.symbol = this.symbol;
        measure.prefix = this.prefix;
        measure.suffix = this.suffix;
        measure.exponent = this.exponent;
        measure.precision = this.precision;
        return measure;
    }
    get extension() {
        return this.prefix + this.symbol + this.suffix;
    }
}

/**
 * Creates a function that finds best looking unit for value from a list of provided units.
 * @param unitKeys an Array of unit identifiers.
 * @returns {(value: number) => Measure} Finds best looking unit for pretty printing and returns Measure with it.
 */
const createMeasureSelector = (...unitKeys) => {
    const units = unitKeys.map(findUnit).sort((a, b) => b.ratio - a.ratio);
    /**
     * Finds best looking unit for pretty printing and returns Measure with it.
     *
     * @param value quantity/value of measure.
     * @returns {Measure} new Measure(value, bestLookingUnit)
     */
    const finder = (value) => {
        const sign = value < 0 ? -1 : 1;
        const absoluteValue = value * sign;
        // console.log({ value, absoluteValue, sign })
        const found = units.reduce(
        // find smallest unit larger than 1
        (previousUnit, currentUnit) => {
            const currentQuantity = Number(new Measure(absoluteValue).to(currentUnit.unitKey));
            const previousQuantity = Number(new Measure(absoluteValue).to(previousUnit.unitKey));
            return previousQuantity < 1 || currentQuantity < previousQuantity
                ? currentUnit
                : previousUnit;
        }, units[0] // default to first/largest unit
        );
        const foundMeasure = new Measure(absoluteValue).to(found.unitKey);
        if (Number(foundMeasure) < 1) {
            return new Measure(absoluteValue * sign).to(units[units.length - 1].unitKey);
        }
        else {
            return new Measure(absoluteValue * sign).to(found.unitKey);
        }
    };
    return finder;
};

export default Measure;
export { createMeasureSelector as measureFrom, rounder };
